<template>
  <div>
    <div class="flex-container">
      <div class="tips">课题名称：{{ mxParams.name }}</div>
      <div class="row">
        <div style="margin: 5px">
          <el-steps align-center>
            <el-step
              :title="item.sname"
              :description="item.bz"
              v-for="(item, index) in progressFlow"
              :key="index"
              :status="
                item.status == 3 || item.status == 7 || item.status == 8
                  ? 'success '
                  : item.status == 4 || item.status == 9 || item.status == 11
                  ? 'error '
                  : item.status == 10 || item.status == 5
                  ? 'process'
                  : 'wait'
              "
            >
              <template slot="description">
                <span>
                  {{ item.sbz }}
                  <br />
                  {{ item.bz }}
                </span>
              </template>
            </el-step>
          </el-steps>
        </div>

        <div style="margin-left: 10px">
          <el-tabs v-model="stepActive">
            <el-tab-pane
              :label="item.sname"
              :name="item.step"
              v-for="(item, index) in progressMenu"
              :key="index"
            >
              <!-- 立项申请-->
              <CourseLxsq
                v-if="item.step == 2"
                :mxParams="mxParams"
              ></CourseLxsq>
              <!-- 月报追踪
              <CourseLxsq v-if="item.step ==11" :mxParams="mxParams"></CourseLxsq>-->
              <!-- 立项评审-->
              <CourseLxps
                v-if="item.step == 3"
                :mxParams="mxParams"
              ></CourseLxps>
              <!-- 中期检查-->
              <CourseZqjc
                v-if="item.step == 14"
                :mxParams="mxParams"
              ></CourseZqjc>
              <!-- 结项申请-->
              <CourseJxsq
                v-if="item.step == 5"
                :mxParams="mxParams"
              ></CourseJxsq>
              <!-- 结项初审-->
              <CourseJxcs
                v-if="item.step == 15"
                :mxParams="mxParams"
              ></CourseJxcs>
              <!-- 结项评审-->
              <CourseJxps
                v-if="item.step == 6"
                :mxParams="mxParams"
              ></CourseJxps>
              <!-- 延期结项申请-->
              <CourseYqjxsq
                v-if="item.step == 12"
                :mxParams="mxParams"
              ></CourseYqjxsq>
              <!-- 延期结项评审-->
              <CourseYqjxps
                v-if="item.step == 13"
                :mxParams="mxParams"
              ></CourseYqjxps>
              <!-- 质量评分-->
              <CourseZlpf
                v-if="item.step == 16"
                :mxParams="mxParams"
              ></CourseZlpf>
              <!-- 延迟结项-->
              <CourseYqjx
                v-if="item.step == 10"
                :mxParams="mxParams"
              ></CourseYqjx>
              <!-- 课题撤销-->
              <CourseKtcx
                v-if="item.step == 9"
                :mxParams="mxParams"
              ></CourseKtcx>
              <!-- 课题相关文档-->
              <courseFile
                v-if="item.step == 17"
                :mxParams="mxParams"
                @hideResultDialog="hideResultDialog"
              ></courseFile>
            </el-tab-pane>
            <!-- <el-tab-pane label="课题撤销" name="8">
              <CourseKtcx :mxParams="mxParams"></CourseKtcx>
            </el-tab-pane>-->
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="bt">
      <div
        @click="handleToLxps()"
        v-if="
          mxParams.courseprop != '3' &&
          mxParams.cstep == 3 &&
          mxParams.cproject != '2' &&
          mxParams.iftwo != 1 &&
          mxParams.cproject != '3' &&
          (mxParams.fwgl == 1 || mxParams.fwps1.indexOf('3_') > -1)
        "
      >
        <el-button type="primary" size="small">立项评审</el-button>
      </div>
      <div
        @click="handleToLxpsSecond()"
        v-if="
          mxParams.iftwo == 1 &&
          (mxParams.fwgl == 1 || mxParams.fwps2.indexOf('3_') > -1)
        "
      >
        <el-button type="primary" size="small">立项二次评审</el-button>
      </div>
      <div
        @click="handleToZqjcps()"
        v-if="
          mxParams.group !== '3' &&
          mxParams.courseprop !== '3' &&
          mxParams.iftwo != 1 &&
          mxParams.cstep == 4 &&
          (mxParams.fwgl == 1 || mxParams.fwps1.indexOf('4_') > -1)
        "
      >
        <el-button type="primary" size="small">中期检查评审</el-button>
      </div>
      <div
        @click="handleToJxcs()"
        v-if="
          mxParams.group === '2' &&
          mxParams.cstep == 15 &&
          (mxParams.fwgl == 1 || mxParams.fwps1.indexOf('15_') > -1)
        "
      >
        <el-button type="primary" size="small">结项初审</el-button>
      </div>
      <div
        @click="handleToJxps()"
        v-if="
          ((mxParams.cstep == 6 && mxParams.group == 2) ||
            ((mxParams.group == 1 || mxParams.group == 3) &&
              mxParams.cstep == 6)) &&
          (mxParams.fwgl == 1 || mxParams.fwps1.indexOf('6_') > -1)
        "
      >
        <el-button type="primary" size="small">结项评审</el-button>
      </div>
      <div
        @click="handleToYqjxps()"
        v-if="
          mxParams.group !== '2' &&
          mxParams.cstep == 13 &&
          mxParams.sfycjx == 1 &&
          (mxParams.fwgl == 1 || mxParams.fwps1.indexOf('13_') > -1)
        "
      >
        <el-button type="primary" size="small">延期结项评审</el-button>
      </div>
      <div
        @click="handleToZlpf()"
        v-if="
          mxParams.group == '3' &&
          mxParams.cstep >= 6 &&
          (mxParams.fwgl == 1 || mxParams.fwps1.indexOf('16_') > -1)
        "
      >
        <el-button type="primary" size="small">质量评分</el-button>
      </div>
    </div>
    <!-- 立项评审 -->
    <el-dialog
      title="立项评审"
      :visible.sync="handleLxpsDialog"
      width="90%"
      v-if="handleLxpsDialog"
      :closeOnClickModal="false"
      append-to-body
    >
      <HandleLxps
        ref="lxpsForm"
        :mxParams="mxParams"
        @getParentForm="getParentForm"
      ></HandleLxps>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleLxpsDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveLxpsForm">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 立项二次评审 -->
    <el-dialog
      title="立项二次评审"
      :visible.sync="handleLxpsSecondDialog"
      width="90%"
      v-if="handleLxpsSecondDialog"
      :closeOnClickModal="false"
      append-to-body
    >
      <HandleLxpsSecond
        ref="lxpsSecondForm"
        :mxParams="mxParams"
        @getParentForm="getParentForm"
      ></HandleLxpsSecond>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleLxpsSecondDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveLxpsSecondForm">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="中期检查评审"
      :visible.sync="zqjcpsFormDialog"
      append-to-body
      width="90%"
      v-if="zqjcpsFormDialog"
      :close-on-click-modal="false"
    >
      <ZqjcpsForm
        :mxParams="this.mxParams"
        ref="zqjcpsForm"
        @getParentForm="getParentForm"
      ></ZqjcpsForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="zqjcpsFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveZqjcpsForm">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="结项初审"
      :visible.sync="jxcsFormDialog"
      width="90%"
      v-if="jxcsFormDialog"
      :close-on-click-modal="false"
      append-to-body
    >
      <JxcsForm
        :mxParams="mxParams"
        ref="jxcsForm"
        @getParentForm="getParentForm"
      ></JxcsForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jxcsFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveJxcsForm">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="结项评审"
      :visible.sync="jxpsFormDialog"
      width="90%"
      v-if="jxpsFormDialog"
      :close-on-click-modal="false"
      append-to-body
    >
      <JxpsForm
        :mxParams="mxParams"
        ref="jxpsForm"
        @getParentForm="getParentForm"
      ></JxpsForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jxpsFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveJxpsForm">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="延期结项评审"
      :visible.sync="yqjxpsFormDialog"
      width="90%"
      v-if="yqjxpsFormDialog"
      :close-on-click-modal="false"
      append-to-body
    >
      <YqjxpsForm
        :mxParams="mxParams"
        ref="yqjxpsForm"
        @getParentForm="getParentForm"
      ></YqjxpsForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="yqjxpsFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveYqjxpsForm">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="质量评分"
      :visible.sync="handleZlpfDialog"
      width="90%"
      v-if="handleZlpfDialog"
      :closeOnClickModal="false"
      append-to-body
    >
      <HandleZlpf
        ref="zlpfForm"
        :mxParams="mxParams"
        @getParentForm="getParentForm"
      ></HandleZlpf>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleZlpfDialog = false">取 消</el-button>

        <el-button type="primary" @click="saveZlpfForm">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { formatMomentDate } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import { getCourseProcess } from "@/api/course.js";
import CourseLxsq from "./courseResult/courseLxsq.vue";
import CourseLxps from "./courseResult/courseLxps.vue";
import CourseZqjc from "./courseResult/courseZqjc.vue";
import CourseJxps from "./courseResult/courseJxps.vue";
import CourseJxsq from "./courseResult/courseJxsq.vue";
import CourseYqjx from "./courseResult/courseYqjx.vue";
import CourseYqjxsq from "./courseResult/courseYqjxsq.vue";
import CourseYqjxps from "./courseResult/courseYqjxps.vue";
import courseFile from "./courseResult/courseFile.vue";
import CourseKtcx from "./courseResult/courseKtcx.vue";
import CourseJxcs from "./courseResult/courseJxcs.vue";
import CourseZlpf from "./courseResult/courseZlpf.vue";
// import HandleLxps from "./courseLxpsForm/handleLxps.vue";
// import HandleLxpsSecond from "./courseLxpsForm/handleLxpsSecond.vue";
// import ZqjcpsForm from "./courseZqjcForm/zqjcpsForm.vue";
// import JxpsForm from "./courseJxpsForm/handleJxps.vue";
// import JxcsForm from "./courseJxpsForm/handleJxcs.vue";
// import YqjxpsForm from "./courseJxpsForm/handleYqjxps.vue";
// import HandleZlpf from "./courseZlpfForm/handleZlpf.vue";

export default {
  name: "courseResult",
  computed: {},
  props: ["mxParams"],
  components: {
    CourseLxsq,
    CourseLxps,
    CourseZqjc,
    CourseJxsq,
    CourseJxps,
    CourseYqjx,
    CourseYqjxsq,
    CourseYqjxps,
    courseFile,
    CourseKtcx,
    CourseJxcs,
    CourseZlpf,
    HandleLxps: () => import("./courseLxpsForm/handleLxps.vue"),
    HandleLxpsSecond: () => import("./courseLxpsForm/handleLxpsSecond.vue"),
    ZqjcpsForm: () => import("./courseZqjcForm/zqjcpsForm.vue"),
    JxcsForm: () => import("./courseJxpsForm/handleJxcs.vue"),
    JxpsForm: () => import("./courseJxpsForm/handleJxps.vue"),
    YqjxpsForm: () => import("./courseJxpsForm/handleYqjxps.vue"),
    HandleZlpf: () => import("./courseZlpfForm/handleZlpf.vue"),
  },
  data() {
    return {
      stepActive: "1",
      progressFlow: [],
      progressMenu: [],
      handleLxpsDialog: false,
      handleLxpsSecondDialog: false,
      zqjcpsFormDialog: false,
      handleZlpfDialog: false,
      jxpsFormDialog: false,
      jxcsFormDialog: false,
      yqjxpsFormDialog: false,
    };
  },

  created() {
    setTimeout(() => {
      this.initData();
    }, 500);
  },
  mounted() {},
  methods: {
    initData() {
      //获取要编辑数据
      if (localStorage.getItem("mxParams")) {
        this.mxParams = JSON.parse(localStorage.getItem("mxParams"));
        localStorage.removeItem("mxParams");
      } else {
      }
      let cid = this.mxParams?.id;
      const params1 = { cid };
      getCourseProcess(params1).then((res) => {
        if (res.code === 0) {
          this.progressFlow = res.data.flow;
          this.progressMenu = res.data.menu;
          this.mxParams.group = res.data.group;
          let i = this.progressMenu.length - 2;
          this.stepActive = this.progressMenu[i].step;
          if (this.mxParams.flieStep) {
            this.stepActive = "17";
          } else {
            if (this.mxParams.step) {
              this.stepActive = this.mxParams.step + "";
            }
          }
        }
      });
    },
    hideResultDialog() {
      this.$emit("hideResultDialog");
    },
    getParentForm() {
      this.$emit("getParentForm");
      this.$emit("hideResultDialog");
    },
    handleToLxps() {
      this.handleLxpsDialog = true;
    },
    handleToLxpsSecond() {
      this.handleLxpsSecondDialog = true;
    },
    handleToZqjcps() {
      this.zqjcpsFormDialog = true;
    },
    handleToJxps() {
      this.jxpsFormDialog = true;
    },
    handleToJxcs() {
      this.jxcsFormDialog = true;
    },
    handleToYqjxps() {
      this.yqjxpsFormDialog = true;
    },
    handleToZlpf() {
      this.handleZlpfDialog = true;
    },
    saveLxpsForm() {
      this.$refs.lxpsForm.saveForm();
    },
    saveLxpsSecondForm() {
      this.$refs.lxpsSecondForm.saveForm();
    },
    saveZqjcpsForm() {
      this.$refs.zqjcpsForm.saveForm();
    },
    saveJxpsForm() {
      this.$refs.jxpsForm.saveForm();
    },
    saveJxcsForm() {
      this.$refs.jxcsForm.saveForm();
    },
    saveYqjxpsForm() {
      this.$refs.yqjxpsForm.saveForm();
    },
    saveZlpfForm() {
      this.$refs.zlpfForm.saveForm();
    },
  },
};
</script>
<style lang="less" scoped>
.flex-container {
  width: 100%;
  height: 100%;
}
.tips {
  background-color: #d7d7d7;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  margin: 15px 0;
}
.bt {
  position: fixed;
  top: 350px;
  right: 50px;
}
</style>